import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import "./AddForm.css";

const AddForm = ({
  show,
  title,
  onClose,
  onSubmit,
  children,
  footerActions,
  contentClassName = ""
}) => {
  if (!show) return null;

  return (
    <div className="add-form-modal-overlay" onClick={onClose}>
      <div className="add-form-modal-card" onClick={(e) => e.stopPropagation()}>
        <div className="add-form-modal-head">
          <div />
          <button
            type="button"
            className="add-form-modal-close"
            onClick={onClose}
            aria-label="Close"
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        <form className="add-form-modal-form" onSubmit={onSubmit}>
          <div className={`add-form-modal-body ${contentClassName}`.trim()}>
            <section className="add-form-modal-section">
              <h5 className="add-form-modal-section-title">{title}</h5>
              {children}
            </section>
          </div>

          <div className="add-form-modal-foot">{footerActions}</div>
        </form>
      </div>
    </div>
  );
};

export default AddForm;
